const ClassTypes = {
    FLYR: 1,
    FLYR_KIDS: 12,
  };
  
  export default ClassTypes;
  